import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { LocalService, ManagerService } from 'src/app/core';

@Component({
  selector: 'app-discussion-board',
  templateUrl: './discussion-board.component.html',
  styleUrls: ['./discussion-board.component.scss']
})
export class DiscussionBoardComponent implements OnInit {

  @Input() chatData: any;
  @Input() approverPage: any;
  @Output() onBackClick = new EventEmitter<void>();
  @Output() onCloseClick = new EventEmitter<void>();
  @ViewChild('scrollContainer') private chatScrollContainer!: ElementRef;

  comments = '';
  userProfile: any;
  chatDataList: any[] = [];
  disableButton = false;

  constructor(private managerService: ManagerService) {}

  ngOnInit() {
    this.userProfile = LocalService.get('userProfile');
    this.getCommentsById();
  }

  getCommentsById() {
    this.disableButton = true;
    this.managerService.getCommentsById(this.chatData).subscribe(
      (data: any) => {
        this.chatDataList = data;
        this.comments = '';
        this.disableButton = false;
        setTimeout(() => {
          try {
            this.chatScrollContainer.nativeElement.scrollTo({
              left: 0,
              top: this.chatScrollContainer.nativeElement.scrollHeight,
              behavior: 'smooth'
            });
          } catch (err) {
            console.warn('Could not scroll chat container', err);
          }
        }, 500);
      },
      (err: any) => { console.log(err); }
    );
  }

  goBackToStatusScreen() {
    this.onBackClick.emit();
  }

  closeDialog() {
    this.onCloseClick.emit();
  }

  addCommentsById() {
    let queryParams: string;
    if (this.chatData.fileData.name === 'chatModal') {
      queryParams = '?fileId=' + this.chatData.fileData.approverData.fileId + '&comments=' + this.comments;
    } else {
      queryParams = '?fileId=' + this.chatData.fileData.id + '&comments=' + this.comments;
    }
    this.managerService.addCommentsById(queryParams).subscribe(
      () => { this.getCommentsById(); },
      (err: any) => { console.log(err); }
    );
  }

  getShortName(name: string): string {
    return (name.match(/\b(\w)/g) || []).join('');
  }

  getLocalDate(data: string | null): string | null {
    return data ? new Date(data).toLocaleDateString() : null;
  }

  getLocalDateAndTime(data: string | null): string | null {
    if (!data) { return null; }
    const options: Intl.DateTimeFormatOptions = { hour: 'numeric', minute: '2-digit' };
    return new Date(data).toLocaleDateString() + ', at ' + new Date(data).toLocaleString('en-US', options);
  }

  getFileType(fileName: string | null): string {
    let fileImage = '<span class="icon-file-o"></span>';
    if (fileName) {
      const extension = (fileName.split('.').pop() || '').toLowerCase();
      if (extension === 'pdf') { fileImage = '<span class="icon-file-pdf-o"></span>'; }
      if (extension === 'xls' || extension === 'xlsx' || extension === 'xlsm') { fileImage = '<span class="icon-file-excel-o"></span>'; }
      if (extension === 'jpg' || extension === 'jpeg' || extension === 'png') { fileImage = '<span class="icon-file-image-o"></span>'; }
    }
    return fileImage;
  }

  getClassByFileType(fileName: string | null): string {
    if (fileName) {
      const extension = (fileName.split('.').pop() || '').toLowerCase();
      if (extension === 'pdf') { return 'text-red-600'; }
      if (extension === 'xls' || extension === 'xlsx' || extension === 'xlsm') { return 'text-green-500'; }
      if (extension === 'jpg' || extension === 'jpeg' || extension === 'png') { return 'text-blue-600'; }
    }
    return 'text-gray-600';
  }
}
